let Pulse = function (props) {
  let size = props.size || 100;
  let margin = props.margin || 0;
  let fill = props.color || "#43b4db";
  let d = "M0.35630016,56.0000019 C3.32043455,80.7853609 24.4163076,100 50,100 C77.6142375,100 100,77.6142375 100,50 C100,22.3857625 77.6142375,0 50,0 L50,9 C72.6436747,9 91,27.3563253 91,50 C91,72.6436747 72.6436747,91 50,91 C29.394481,91 12.3392385,75.799459 9.43589752,56.0000019 L0.35630016,56.0000019 L0.35630016,56.0000019 Z";

  return (
    <div className="mc-pulse" style={{ margin }}>
      <svg width={size} height={size}>
        <g transform={"scale(" + (size / 100) + ")"}>
          <path d={d} fill={fill}/>
        </g>
      </svg>
    </div>
  );
};

module.exports = Pulse;
